module.exports = __webpack_public_path__ + "img/logo-icontec.f7d9b306.png";